import { CollaboratorState } from './state';
import { Collaborator } from '@services/collaborator/types/collaborator';
import { ValidType } from '@services/collaborator/types/valid-types';

export const assetCollaborators = (
  assets: CollaboratorState['assets'],
  assetId: string,
  type?: ValidType
): Collaborator[] => {
  if (!(assetId in assets)) {
    return [];
  }
  return Object.values(assets[assetId])
    .filter((o) => (type ? o.type === type : true))
    .sort(
      (a, b) =>
        (a.order === undefined ? 1 : a.order) -
        (b.order === undefined ? 1 : b.order)
    );
};

export const collaboratorsList = (
  state: CollaboratorState,
  assetId: string
): Collaborator[] => {
  return assetCollaborators(state.assets, assetId, 'COLLABORATOR');
};

export const ComposersList = (
  state: CollaboratorState,
  assetId: string
): Collaborator[] => {
  return assetCollaborators(state.assets, assetId, 'USER');
};
export const contributorsList = (
  state: CollaboratorState,
  assetId: string
): Collaborator[] => {
  return assetCollaborators(state.assets, assetId, 'CONTRIBUTOR');
};
